/**
 * @module ajax
 * @description 请求模块
 * @author: Yawei Wang
 * @date: 2019-06-03 10:31:27
 */
import axios from 'axios';
import qs from 'qs';
import { cookie } from '../cookie';

let catchFn = err => {
  return err;
};
/**
 * 设置异常处理函数
 * @param fn 异常处理函数
 */


export const setCatch = fn => {
  if (fn && typeof fn === 'function') {
    catchFn = fn;
  }
}; // axios.request(config)
// axios.get(url[, config])
// axios.delete(url[, config])
// axios.head(url[, config])
// axios.post(url[, data[, config]])
// axios.put(url[, data[, config]])
// axios.patch(url[, data[, config]])

axios.defaults.withCredentials = true; // 设置不默认带x-xsrf-token头部

axios.defaults.xsrfCookieName = ''; // 必须设置

axios.defaults.xsrfHeaderName = ''; // 可以不设置，后者依赖前者

/**
 * 请求添加 xsrf 参数
 * @function
 * @param {Object} data
 */

export const withXsrf = data => {
  if (typeof data === 'object') {
    data._xsrf = cookie.get('_xsrf');
  } else {
    data = {};
    data._xsrf = cookie.get('_xsrf');
  }

  return data;
};

function updateQueryStringParameter(uri, key, value) {
  if (!value) {
    return uri;
  }

  const re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
  const separator = uri.indexOf('?') !== -1 ? "&" : "?";

  if (uri.match(re)) {
    return uri.replace(re, '$1' + key + "=" + value + '$2');
  } else {
    return uri + separator + key + "=" + value;
  }
}
/**
 * 发送 post 请求
 *
 * @param {string} url 请求地址
 * @param {*} [data={}] 请求参数
 * @param {Object} [headers={}] 其它头部配置
 * @returns {Promise}
 */


export const postJson = (url, data = {}, headers = {}) => {
  // data = withXsrf(data)
  const {
    contentType,
    ...restHeaders
  } = headers;

  if (contentType !== 'application/json' && contentType !== 'text/plain') {
    data = qs.stringify(data);
  }

  return axios.post(updateQueryStringParameter(url, 'ts', new Date().getTime()), data, {
    headers: { ...restHeaders,
      'Content-Type': contentType || 'application/x-www-form-urlencoded'
    }
  }).then(res => {
    return res.data;
  }).catch(err => {
    return err;
  });
};
/**
 * 发送 Get 请求
 * @function
 * @param {String} url 地址
 * @param {Object} data 参数
 */

export const getJson = (url, data = {}, headers = {}) => {
  return axios.get(updateQueryStringParameter(url, 'ts', new Date().getTime()), {
    params: data,
    headers: { ...headers
    }
  }).then(res => {
    return res.data;
  }).catch(err => {
    return catchFn(err);
  });
};
/**
 * 发送 Delete 请求
 * @function
 * @param {String} url 请求地址
 * @param {Object} data 请求参数
 * @param {Object} options 其它配置
 */

export const deleteJson = (url, data = {}, options = {}) => {
  // data = withXsrf(data)
  return axios.delete(url, {
    headers: { ...options,
      'Content-Type': options.contentType || 'application/x-www-form-urlencoded'
    },
    params: data
  }).then(res => {
    return res.data;
  }).catch(err => {
    return catchFn(err);
  });
};
/**
 * 发送 Delete 请求
 * @function
 * @param {String} url 请求地址
 * @param {Object} data 请求参数
 * @param {Object} options 其它配置
 */

export const deletePureJson = (url, data = {}) => {
  return deleteJson(url, data, {
    'Content-Type': 'application/json'
  });
};
/**
 * 发送 Put 请求
 * @function
 * @param {String} url 请求地址
 * @param {Object} data 请求参数
 * @param {Object} options 其它配置
 */

export const putJson = (url, data = {}, options = {}) => {
  // data = withXsrf(data)
  return axios.put(url, qs.stringify(data), {
    headers: { ...options,
      'Content-Type': options.contentType || 'application/x-www-form-urlencoded'
    }
  }).then(res => {
    return res.data;
  }).catch(err => {
    return catchFn(err);
  });
};
/**
 * 发送文件请求
 * @function
 * @param {String} url 请求地址
 * @param {Object} data 请求参数
 */

export const postFile = (url, data) => {
  // data = withXsrf(data)
  const config = {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  };
  return axios.post(url, data, config).then(res => {
    return res.data;
  }).catch(err => {
    return catchFn(err);
  });
};
/**
 * 发送文本（支持进度回调）
 * @function
 * @param {String} url
 * @param {Object} data
 * @param {Function} callback
 * @param {Object} source
 */

export const postFileProgress = (url, data, callback, source) => {
  // data = withXsrf(data)
  const config = {
    cancelToken: source.token,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    onUploadProgress: callback
  };
  return axios.post(url, data, config).then(res => {
    return res.data;
  }).catch(err => {
    if (axios.isCancel(err)) {
      console.log('Request canceled', err.message);
    } else {
      return catchFn(err);
    }
  });
};
/**
 * 发送 post 请求 application/json格式
 * @function
 * @param {String} url 请求地址
 * @param {Object} data 请求参数
 * @param {Object} options 其它配置
 * @returns {Promise}
 */

export const postJsonWithJson = (url, data = {}, options = {}) => {
  // data = withXsrf(data)
  return axios.post(url, qs.stringify(data), {
    headers: { ...options,
      'Content-Type': 'application/json'
    }
  }).then(res => {
    return res.data;
  }).catch(err => {
    return catchFn(err);
  });
};
/**
 * 发送 post 请求 application/json格式  data未被序列化
 * @function
 * @param {String} url 请求地址
 * @param {Object} data 请求参数
 * @param {Object} options 其它配置
 * @returns {Promise}
 */

export const post = (url, data = {}, options = {}) => {
  // data = withXsrf(data)
  return axios.post(updateQueryStringParameter(url, 'ts', new Date().getTime()), data, {
    headers: { ...options,
      'Content-Type': 'application/json'
    }
  }).then(res => {
    return res.data;
  }).catch(err => {
    return catchFn(err);
  });
};
/**
 * 发送 patch 请求
 * @function
 * @param {String} url 请求地址
 * @param {Object} data 请求参数
 * @param {Object} options 其它配置
 */

export const patch = (url, data = {}, options = {}) => {
  // data = withXsrf(data)
  return axios.patch(url, qs.stringify(data), {
    headers: { ...options,
      'Content-Type': options.contentType || 'application/x-www-form-urlencoded'
    }
  }).then(res => {
    return res.data;
  }).catch(err => {
    return catchFn(err);
  });
};
/**
 * 发送 patch 请求 application/json格式  data未被序列化
 * @function
 * @param {String} url 请求地址
 * @param {Object} data 请求参数
 * @param {Object} options 其它配置
 * @returns {Promise}
 */

export const patchJson = (url, data = {}, options = {}) => {
  // data = withXsrf(data)
  return axios.patch(updateQueryStringParameter(url, 'ts', new Date().getTime()), data, {
    headers: { ...options,
      'Content-Type': 'application/json'
    }
  }).then(res => {
    return res.data;
  }).catch(err => {
    return catchFn(err);
  });
};
/**
 * 发送 Put 请求
 * @function
 * @param {String} url 请求地址
 * @param {Object} data 请求参数
 * @param {Object} options 其它配置
 */

export const putPureJson = (url, data = {}, options = {}) => {
  // data = withXsrf(data)
  return axios.put(url, data, {
    headers: { ...options,
      'Content-Type': 'application/json'
    }
  }).then(res => {
    return res.data;
  }).catch(err => {
    return catchFn(err);
  });
};
/**
 * 发送 Put 请求
 * @function
 * @param {String} url 请求地址
 * @param {Object} data 请求参数
 * @param {Object} options 其它配置
 */

export const patchPureJson = (url, data = {}, options = {}) => {
  // data = withXsrf(data)
  return axios.patch(url, data, {
    headers: { ...options,
      "Content-Type": "application/json"
    }
  }).then(res => {
    return res.data;
  }).catch(err => {
    return catchFn(err);
  });
};